export default class PdfExportService {

}
